export default {
  props: {
    // 源数据
    treeData: {
      type: Array,
      default: function() {
        return [];
      },
    },

    // 树节点是否默认展开
    treeExpandAll: {
      type: Boolean,
      default: true,
    },

    // 树节点唯一标识
    treeNodeKey: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      defaultProps: {
        children: "children",
        label: "name",
      },
      selectItem: {},
    };
  },

  methods: {
    // 添加新增按钮
    // handleAdd(data) {
    // 	this.$emit('addItem', data);
    // },

    // 点击编辑标记目录图标。
    handleEdit(data) {
      this.selectItem = data;
      this.$emit("editItem", JSON.parse(JSON.stringify(data)));
    },
    // 点击删除标记目录图标。
    handleDelete(data) {
      this.$emit("deleteItem", data);
    },

    // 点击编辑标记图标。
    markEdit(data) {
      this.selectItem = data;
      let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
      this.$GLOBAL.markDrawGraphicLayerObj = layer;
      this.$emit("editMark", JSON.parse(JSON.stringify(data)));

      // console.log(1111111111111);
      // console.log(JSON.parse(JSON.stringify(data)));
      // console.log(JSON.parse(JSON.stringify(this.$GLOBAL.markDrawGraphicLayer)));
      // console.log(layer);
    },
    // 点击删除标记图标。
    markDelete(data) {
      let layer = this.$GLOBAL.markDrawGraphicLayer.getGraphicById(data.uid);
      this.$GLOBAL.markDrawGraphicLayerObj = layer;
      this.$emit("deleteMark", data);
    },

    // ============== 组件内事件 结束=============

    // ============== 父组件回调事件 开始=============

    // 添加新记录，树形列表回显
    treeAddItem(data) {
      this.$refs.markLTree.append(data, data.parentId);
    },

    // 删除节点
    treeDeleteItem(val) {
      this.$refs.markLTree.remove(val);
    },

    // 修改记录，树形列表回显
    treeEditItem(val) {
      //console.log(this.$parent.getData);
      // console.log(JSON.parse(JSON.stringify(val)));
      // console.log(22222222222);
      Object.assign(this.selectItem, val);
      this.selectItem = {};
      this.$emit("refreshTreeData"); //刷新树
      //this.$parent.initTreeData();
    },
    nodeClick(data) {
      //alert(0)
      //还有一层el-scrollbar组件在里面。
      this.$parent.$parent.markNodeClick(data);
    },

    // ============== 父组件回调事件 结束=============
  },
};
